function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M36.7 52.3C35 50 12.3 73 .5 64.9a5.1 5.1 0 00.8 4 5 5 0 003.2 1.9C10.8 72 23.4 65.3 33 58l1.3-1c5.2 8.8 17.4 27.3 26.3 22.8 1-.5 1.7-1.1 2.2-2l-.8.4c-10.7 4.5-22.7-21.7-25.4-26zM6.5 22.8c-3-3-1.2-5.7.3-7.2-2.1 0-3.7.8-4.6 2.2-2 2.7-.6 6.7 3.8 12 3.2 4 8 8.3 13.4 12.4C29 38 10.7 27 6.5 22.8zM80.1 32.6c-.3-1.5-1.4-2.7-3.2-3.6l.1.5c1.6 6.7-10 10.6-18.4 13.1-8.5 2.6-2.5 6.2-2.5 6.2 10.6-3.3 25.6-9.6 24-16.2z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M60.2 42.9c8.5-2.7 18.4-6.7 16.8-13.4V29c-1.2-.5-2.4-.9-3.6-1-4.6-1-12.8-.5-20.7.8l-4 1.4c-3 1.4-2.2-6.3.6-22.2 1.1-6.4-3-8-3-8-7-1.3-12.8 14-15.6 25-7.4-4.7-14.7-8-20-9.1a16 16 0 00-3.9-.4c-1.5 1.5-3.3 4.2-.3 7.3 4.2 4.2 22.5 15 13 19.4l.1.1C13.6 47 8.4 51.9 5 56.5c-2.6 3.3-4 6.1-4.4 8.4 11.8 10.9 34.7-15.1 36.2-12.7 1.5 2.7 13.8 31.4 25.4 26l.8-.4c3.8-5.9-2-19.8-6.9-29.1 0 0-2.3-3.7 4.2-5.8z",
  fill: "#EEC81F"
}), React.createElement("path", {
  d: "M48.8 8c-.9 4.4-3.8 24-1 22.6 1.6-.7 3.2-1.3 4.9-1.8l-2 .4c1.9-11.3 2.7-27.6-4.4-29 0 0 3.4 3.3 2.5 7.8z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M13.3 23.5a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M12.3 23.1a1.6 1.6 0 11-3.2-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M11.3 22.4a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M36.3 32.7a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M35.3 32.3a1.6 1.6 0 11-3.2-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M34.2 31.6a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M41.7 37a2.3 2.3 0 11-4.5-.8 2.3 2.3 0 014.5.9z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M40.7 36.7a1.6 1.6 0 11-3.2-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M39.6 36a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M48.6 35.5a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M47.5 35.1a1.6 1.6 0 11-3.2-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M46.5 34.4a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M61.8 31.6a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M60.7 31.3a1.6 1.6 0 11-3.1-.7 1.6 1.6 0 013.1.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M59.7 30.5a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M68.3 30.8a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M67.2 30.4a1.6 1.6 0 11-3.1-.6 1.6 1.6 0 013.1.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M66.2 29.7a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M75.3 31.4a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M74.2 31a1.6 1.6 0 11-3.1-.6 1.6 1.6 0 013.1.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M73.2 30.3a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M42.7 30.7a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M41.6 30.3a1.6 1.6 0 11-.2-1.2c.2.4.3.8.2 1.2z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M40.6 29.6a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M43.6 23.7a2.3 2.3 0 11-4.6-.9 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M42.5 23.4a1.6 1.6 0 11-3.1-.6 1.6 1.6 0 013.1.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M41.5 22.7a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M45.7 17.2a2.3 2.3 0 11-4.5-.9 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M44.7 16.9a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M43.7 16.2a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M45.7 10.7a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M44.7 10.3a1.6 1.6 0 11-3.2-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M43.6 9.6a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M40.8 14a2.3 2.3 0 11-4.6-.9 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M39.7 13.7a1.6 1.6 0 11-3.1-.7 1.6 1.6 0 013.1.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M38.7 13a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M46.7 5.5a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M45.6 5.2a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M44.6 4.5A.8.8 0 1143 4a.8.8 0 011.5.4z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M19.5 22a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M18.4 21.6a1.6 1.6 0 11-3.1-.6 1.6 1.6 0 013.1.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M17.4 21a.8.8 0 11-1.5-.3.8.8 0 011.5.2z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M20.7 28.7a2.3 2.3 0 11-4.5-.9 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M19.7 28.4a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M18.7 27.7a.8.8 0 11-1.6-.3.8.8 0 011.6.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M26 32.6a2.3 2.3 0 11-4.5-.9 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M25 32.3a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M24 31.6a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M31.6 36.4a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M30.5 36a1.6 1.6 0 11-3.1-.6 1.6 1.6 0 013.1.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M29.5 35.3A.8.8 0 1128 35a.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M37 40.8a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M36 40.4a1.6 1.6 0 11-3.3-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M34.9 39.7a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M29.8 42.8a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M28.7 42.4a1.6 1.6 0 11-3.1-.6 1.6 1.6 0 013.1.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M27.7 41.7a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M24.1 46a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M23.1 45.6a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M22 44.9a.8.8 0 11-1.4-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M19.2 50.2a2.3 2.3 0 11-4.6-.5 2.3 2.3 0 014.6.5z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M18.1 50a1.6 1.6 0 11-3.2-.4 1.6 1.6 0 013.2.4z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M17 49.3a.8.8 0 11-1.5-.1.8.8 0 011.6.1z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M14.9 54.7a2.3 2.3 0 11-4.6-.9 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M13.8 54.4a1.6 1.6 0 11-3.1-.7 1.6 1.6 0 013.1.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M12.8 53.7a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M9.8 60.6a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M8.8 60.3a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M7.8 59.5a.8.8 0 11-1.6-.3.8.8 0 011.6.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M16 59.6a2.3 2.3 0 11-4.7-.3 2.3 2.3 0 014.6.3z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M14.9 59.4a1.6 1.6 0 11-3.3-.2 1.6 1.6 0 013.3.2z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M13.7 58.8a.8.8 0 11-1.5 0 .8.8 0 011.5 0z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M20.9 55.4a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M19.8 55a1.6 1.6 0 11-3.1-.6 1.6 1.6 0 013.1.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M18.8 54.3a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M26.7 51.8a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M25.7 51.4a1.6 1.6 0 11-3.2-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M24.7 50.7a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M33 47.7a2.3 2.3 0 11-4.5-.9 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M32 47.4a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M31 46.7a.8.8 0 11-1.6-.3.8.8 0 011.6.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M52.4 47.4a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M51.4 47a1.6 1.6 0 11-3.2-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M50.4 46.3a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M55.4 52.6a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M54.3 52.3a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M53.3 51.5a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M58.5 58a2.3 2.3 0 11-4.5-.9 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M57.5 57.7a1.6 1.6 0 11-3.2-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M56.5 57a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M61 64.4a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M60 64a1.6 1.6 0 11-3.1-.6 1.6 1.6 0 013.1.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M59 63.3a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M54.2 62a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M53.1 61.6A1.6 1.6 0 1150 61a1.6 1.6 0 013.1.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M52.1 60.9a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M51.8 57a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M50.8 56.7a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M49.8 56a.8.8 0 11-1.5-.4.8.8 0 011.5.4z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M49 53.1a2.3 2.3 0 11-4.5-.9 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M48 52.8a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M47 52a.8.8 0 11-1.6-.2.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M47 48.3a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M46 48a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M45 47.2a.8.8 0 11-1.6-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M62.6 70.5a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M61.6 70.1a1.6 1.6 0 11-3.2-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M60.6 69.4A.8.8 0 1159 69a.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M62.1 76.3a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M61 76a1.6 1.6 0 11-3.1-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M60 75.2a.8.8 0 11-1.5-.3.8.8 0 111.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M57.5 72.7a2.3 2.3 0 11-4.5-.9 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M56.5 72.4a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M55.5 71.7a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M56.4 67.2a2.3 2.3 0 11-4.6-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M55.3 66.8a1.6 1.6 0 11-3.1-.6 1.6 1.6 0 013.1.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M54.3 66.1a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M44.1 43.3a2.3 2.3 0 11-4.5-.9 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M43 43a1.6 1.6 0 11-3.1-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M42 42.3a.8.8 0 11-1.5-.3.8.8 0 011.6.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M50.4 41.4a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M49.4 41a1.6 1.6 0 11-3.2-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M48.3 40.3a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M56.6 38.2a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M55.6 37.8a1.6 1.6 0 11-3.2-.6 1.6 1.6 0 013.2.6z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M54.6 37.1a.8.8 0 11-1.5-.3.8.8 0 011.5.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M64 37a2.3 2.3 0 11-4.5-1 2.3 2.3 0 014.6 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M63 36.7a1.6 1.6 0 11-3.2-.7 1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M62 36a.8.8 0 11-1.5-.4.8.8 0 01.9-.6.8.8 0 01.6 1z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M71.2 36a2.3 2.3 0 11-4.5-.9 2.3 2.3 0 014.5 1z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M70.2 35.7A1.6 1.6 0 1167 35a1.6 1.6 0 013.2.7z",
  fill: "#EED51F"
}), React.createElement("path", {
  d: "M69.2 35a.8.8 0 11-1.6-.3.8.8 0 011.6.3z",
  fill: "#F5FF6D"
}), React.createElement("path", {
  d: "M35.3 19.2A7.3 7.3 0 1124 28.4a7.3 7.3 0 0111.3-9.2z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M35.2 17.4a7.3 7.3 0 11-11.3 9.3 7.3 7.3 0 0111.3-9.3z",
  fill: "#EEC81F"
}), React.createElement("path", {
  d: "M33.7 19a5 5 0 11-7.7 6.4 5 5 0 017.7-6.4z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M30.4 21.9a1.6 1.6 0 11-2.6 2 1.6 1.6 0 012.6-2z",
  fill: "#000"
}), React.createElement("path", {
  d: "M58.2 30.1A7.3 7.3 0 1144.3 26a7.3 7.3 0 0114 4.2z",
  fill: "#EEA700"
}), React.createElement("path", {
  d: "M59.7 29a7.3 7.3 0 11-14-4.2 7.3 7.3 0 0114 4.2z",
  fill: "#EEC81F"
}), React.createElement("path", {
  d: "M57.5 28.7a5 5 0 11-9.6-2.9 5 5 0 019.6 2.9z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M53.2 27.5a1.6 1.6 0 11-3.1-1 1.6 1.6 0 013.1 1z",
  fill: "#000"
}), React.createElement("path", {
  d: "M.6 67.5s.7 7 11 4.6c10.3-2.5 22.6-12.4 22.6-12.4s12.2 24 23.7 21l1.8-.5s-6.6-.2-10.4-4.9A362.2 362.2 0 0135 54.5s-2 2.6-7.4 6.3C22.3 64.5 7.4 75 .7 67.5zM1.7 18.5s-3.5 3.5 2 10.4C9 35.8 18.5 43.4 18.5 43.4l1.8-1.4c-3-3.9-6.4-7.4-10.2-10.4-3.2-2.7-9.4-9-8.4-13.1zM80 34.6s1 4.4-3.7 7.3a186 186 0 01-19.5 8.4l-1-2.1s1.7-2.2 7.3-3.7c5.6-1.4 14.5-4.3 17-9.9z",
  fill: "#EB0"
}), React.createElement("path", {
  d: "M18.5 43.3l-6.7-6.5c-2.7-2.7-5.3-5.6-7.7-8.5L2.3 26a18.5 18.5 0 01-1-1.7l-.3-.5c-1-2.2.5-5 1.2-6-.5.8-2.7 3-2.1 6l.2.9.3.7.8 1.3L3.1 29a97.6 97.6 0 0014.3 15l1-.8z",
  fill: "#D79800"
}), React.createElement("path", {
  d: "M46 39c-3.7-1-4.9 8.1-10.8 2-2.6-3.4-8.8-8-2.5 2.4 5 8.4 13.3 0 13.3-4.4z",
  fill: "#000",
  stroke: "#000"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 88.2,
  height: 89,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dx: 4,
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgStarfishSmile = function SvgStarfishSmile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 89,
    height: 89,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStarfishSmile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/starfish-smile.3ae07860.svg";
export { ForwardRef as ReactComponent };